module.exports = __webpack_public_path__ + "img/room-y2.b331918c.jpg";